import { RDEqipEligibilityConservationCSP } from '@cibo/core'
import { conservationProgram } from '../ConservationPrograms'

export const ConservationCSP = conservationProgram<RDEqipEligibilityConservationCSP>(
  'cspEnrolled',
  'CSP',
  'eqipEligibilityConservationCSP',
  '@cibo/landmanager/ConservationCSP'
)
